import { render, staticRenderFns } from "./TrainingCenter.vue?vue&type=template&id=113b569f&scoped=true&"
import script from "./TrainingCenter.vue?vue&type=script&lang=js&"
export * from "./TrainingCenter.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCenter.vue?vue&type=style&index=0&id=113b569f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b569f",
  null
  
)

export default component.exports